<script lang="ts">
	import BreakerBasicView from 'src/components/Sidepanel/DeviceViews/Breaker/BreakerBasicView.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<BreakerBasicView {device} />
